import React from "react";
import PropTypes from "prop-types";
import { Breadcrumbs as PdsBreadcrumbs } from "@politiet/pds";

export default function Breadcrumbs({ Paths, Negative, Standalone }) {
    if (typeof window !== "undefined") {
        addBreadcrumbListeners();
    }

    function addBreadcrumbListeners() {
        const breadcrumbContainer = document.querySelector(".pds-breadcrumbs");
        if (!breadcrumbContainer) return;

        const links = breadcrumbContainer.querySelectorAll("a");
        for (let i = 0; i < links.length; i++) {
            links[i].onclick = handleBreadcrumbClick;
        }
    }

    function handleBreadcrumbClick(event) {
        event.preventDefault();
        const breadcrumbText = event.target.textContent.trim();
        const breadcrumbHref = event.target.href;

        // Matomo tracking
        if (window._paq) {
            window._paq.push([
                "trackEvent",
                "breadcrumbs",
                "click breadcrumb",
                `${breadcrumbText} - ${document.title} (${window.location.pathname})`,
            ]);
        }

        window.location.href = breadcrumbHref;
    }

    return (
        <PdsBreadcrumbs
            breadcrumbs={JSON.parse(Paths)}
            className="list--reset-style"
            isNegative={Negative}
            isStandalone={Standalone}
        />
    );
}

Breadcrumbs.propTypes = {
    Negative: PropTypes.bool,
    Standalone: PropTypes.bool,
    Paths: PropTypes.string.isRequired,
};
